import { render, staticRenderFns } from "./ResearchAdd.vue?vue&type=template&id=1fca2352"
import script from "./ResearchAdd.vue?vue&type=script&lang=js"
export * from "./ResearchAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports